import { c as _c } from "react/compiler-runtime";
import { InputAdornment, Tooltip } from '@mui/material';
export const InputErrorIcon = t0 => {
  const $ = _c(4);
  const {
    errorMessage
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      tooltip: {
        sx: {
          backgroundColor: "var(--mui-palette-error-main)",
          userSelect: "text",
          cursor: "text"
        }
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = errorMessage || "Invalid input";
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <i className="material-symbols-error-outline-rounded bg-(--mui-palette-error-main)" />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2) {
    t4 = <InputAdornment position="start"><Tooltip disableInteractive={false} slotProps={t1} title={t2}>{t3}</Tooltip></InputAdornment>;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};